// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__WVfh_","author":"Table_author__2u4hn","authorImage":"Table_authorImage__5RW30","unreadRow":"Table_unreadRow__2a0aM"};